import React, { FC } from 'react'
import { ProcedureElement } from 'Pages/landings/newLandings/common/components'
import { Wrapper, Title, Text, Href } from './styled'

export const ProcedureComponent: FC = () => (
	<Wrapper>
		<Title>Как подключить эквайринг</Title>
		<ProcedureElement
			number="1"
			text={() => (
				<Text>
					Оставьте заявку через сайт или подключите самостоятельно&nbsp;
					<Href href="http://www.sberbank.ru/help/business/sbbol/100292">по инструкции</Href> через
					интернет-банк СберБизнес
				</Text>
			)}
		/>
		<ProcedureElement number="2" text="Ожидайте СМС" />
		<ProcedureElement
			number="3"
			text="Подпишите договор и договоритесь о подключении в удобное для вас время"
		/>
	</Wrapper>
)
